import React, { Component } from 'react'
import { Module, FormData } from 'components/misc'
import { Checkbox } from 'components/fields'
import PropTypes from 'prop-types'

import { permissions } from 'helpers/decorators'
import { get } from 'lodash'
import { ROLES } from 'constants/enums'
import { apiContacts } from '../../../../helpers/decorators/api'

@permissions()
@apiContacts({
  active: true
})
class ContactRestrictions extends Component {
  static propTypes = {
    permissions: PropTypes.object,
    data: PropTypes.object.isRequired,
    contacts: PropTypes.object.isRequired
  }

  render() {
    const { permissions: appPermissions, persons, contacts } = this.props

    let isExtendedRole = get(contacts, 'active.isExtendedRole') || false
    const disableMFA = appPermissions.isIfSuper || appPermissions.isGbt || (appPermissions.isNaoStaff && isExtendedRole)
    const disableNaoCustomization = appPermissions.isIfSuper || appPermissions.isGbt
    const disableIsExtendedRole = appPermissions.isIfSuper || appPermissions.isGbt

    const roles =  get(persons, 'roles', [])

    const hasNaoRolesAndHigher = roles.map(r =>
      get(r, 'organizationContactRoleType.value') === ROLES.NAO_STAFF.role ||
      get(r, 'organizationContactRoleType.value') === ROLES.IF_STAFF_SUPER.roles ||
      get(r, 'organizationContactRoleType.value') === ROLES.IF_STAFF_USER.role ||
      get(r, 'organizationContactRoleType.value') === ROLES.IF_STAFF_STATISTICAL_USER.role ||
      get(r, 'organizationContactRoleType.value') === ROLES.IF_STAFF_VIEWER.role).includes(true)

    return (
      <div>
        <Module
          title="Restrictions"
          intlKey="moduleTitle.restrictions"
          primary
          first
          grid
        >
          <div className="row">
            <div className="col-xs-3">
              <FormData label="ORB Testing" intlKey="label.orb_testing">
                <Checkbox name="isTestUser" label="CTEST access" intl="label.ctest_access" />
              </FormData>
            </div>
            {hasNaoRolesAndHigher && <div className="col-xs-3">
              <FormData label="MFA Authentication" intlKey="label.mfa_authentication">
                <Checkbox name="isMfaEnabled" label="Enabled" intl="label.enabled" disabled={!disableMFA} />
              </FormData>
            </div>}
            {hasNaoRolesAndHigher && <div className="col-xs-3">
              <FormData label="NAO Customizations" intlKey="label.nao_customizations">
                <Checkbox name="editCustomizationEnabled" label="Enabled" intl="label.enabled" disabled={!disableNaoCustomization} />
              </FormData>
            </div>}
            {hasNaoRolesAndHigher && <div className="col-xs-3">
              <FormData label="Lead NAO account" intlKey="label.lead_nao">
                <Checkbox name="isExtendedRole" label="Enabled" intl="label.enabled" disabled={!disableIsExtendedRole} />
              </FormData>
            </div>}
          </div>
        </Module>
      </div>
    )
  }
}

export default ContactRestrictions
